<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit">{{$t('Security.User.username')}}:</div>
        <input class="e-input e-input-group" id="userName" name="UserName" maxLength="25" v-model="userName" @blur="setChildProps" @keydown="stopEvent"/>
      </div>
    </div>
    <div v-show="showState" class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit">{{dropdownMessage}}:</div>
        <ejs-dropdownlist class="e-input" ref="list" :dataSource='dataSource' :index='0' @change="setChildProps"></ejs-dropdownlist>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit">{{$t('Security.selectDate')}}:</div>
        <ejs-daterangepicker
          class="e-input"
          ref="datePicker"
          :format="dateFormat"
          :separator="separate"
          @change="setChildProps"
          :allowEdit="false"
          :max="endDate"
          v-model="pickerTime"
          @keydown.native="stopEvent"
        ></ejs-daterangepicker>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdvancedSearch",
  props: {
    signInOrOperation: Number
  },
  data() {
    return {
      userName: "",
      signInDropdownList: [
        { text: `${this.$t('Common.all')}`, value: '' },
        { text: `${this.$t('Security.success')}`, value: 1 },
        { text: `${this.$t('Security.failure')}`, value: 0 }
      ],
      operDropdownList: [
        { text: `${this.$t('Common.all')}`, value: "" }
      ],
      dateFormat: "yyyy-MM-dd",
      dropdownMessage: `${this.$t('Security.Log.result')}`,
      separate: "~",
      pickerTime: '',
      dataSource: [],
      showState: true,
      endDate: new Date()
    };
  },
  methods: {
    setChildProps() {
      let props = {userName: this.userName, time: this.pickerTime};
      if(this.$refs.list.ej2Instances.index != null){
        if(this.signInOrOperation === 0){
          props.dropdownList = this.signInDropdownList[this.$refs.list.ej2Instances.index].value;
        }else{
          props.dropdownList = '';
        }
      }
      this.$emit("childProps",props);
    },
    setParams() {
      if (this.signInOrOperation === 0) {
        this.showState = true;
        this.dropdownMessage = `${this.$t('Security.Log.result')}`;
        this.dataSource = this.signInDropdownList;
        this.$refs.list.ej2Instances.index = 0;
        this.dateFormat = 'yyyy-MM-dd';
      } else {
        // this.dropdownMessage = `${this.$t('Security.Log.module')}`;
        // this.findOperName();
        this.showState = false;
        this.dateFormat = "yyyy-MM-dd";
      }
    },
    findOperName() {
      let That = this;
      this.$axios.get('/lte/ems/res/findResource', { params: { parentId: 0 }} ).then((res) => {
        let result = res.data;
        let list = [];
        if(result!=null) {
          list.push({ text: `${That.$t('Common.all')}`, value: "" });
          result.forEach((rd) => {
            let item = { text: rd.nameStr, value: rd.resKey };
            list.push(item);
          });
        }
        That.operDropdownList = list;
        That.dataSource = That.operDropdownList;
        That.$refs.list.ej2Instances.index = 0;
      })
    },
    stopEvent(event) {
      console.log("ssss")
      if (event.keyCode == 13) {
        event.cancelBubble = true;
        event.returnValue = false;
        return false;
      }
    }
  },
  watch: {
    signInOrOperation() {
      this.setParams();
    }
  },
  mounted() {
    this.setParams();
  }
};
</script>
